import apiHelper from '@/utils/apiHelper';
import getVisiblePropertiesText from '@/utils/getVisiblePropertiesText';
import { capitalize } from '@/utils/stringHelpers';
import i18n from '@/config/i18n';

const { t } = i18n.global;

const getBrandsAndClusters = async () => {
  const { data } = await apiHelper(
    'GET',
    '/brands-clusters',
  );

  return data.data
    .map((item) => ({
      ...item,
      typeText: t(capitalize(item.type)),
      visibleInText: item.type === 'brand' || !item.visibleProperties.length
        ? t('Overview')
        : `${t('Overview')} + ${getVisiblePropertiesText(item.visibleProperties)}`,
    }));
};

export default getBrandsAndClusters;
